import { render, staticRenderFns } from "./GestionGrupos.vue?vue&type=template&id=8e334c64&scoped=true&"
import script from "./GestionGrupos.vue?vue&type=script&lang=js&"
export * from "./GestionGrupos.vue?vue&type=script&lang=js&"
import style0 from "./GestionGrupos.vue?vue&type=style&index=0&id=8e334c64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e334c64",
  null
  
)

export default component.exports